import { render, staticRenderFns } from "./PieChartComponent.vue?vue&type=template&id=10080c92"
import script from "./PieChartComponent.vue?vue&type=script&lang=js"
export * from "./PieChartComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports